// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

const logArgs = { eventName: "stChH_stateChange", inline: true, disabled: true };
const msgs = {
  stateChange: (CHANGE) => [`playbackProgress: ${CHANGE}`],
  no_change: ["No change to state provided."],
  no_someEl: ["state change hdl.", "stateChange", "no some el. found"],
};

// —————————————————————————————————————————— HDL. DEF. ——————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default function stChH_playbackProgress(CHANGES) {
  if (!("playbackProgress" in CHANGES)) return this.logger("error", msgs.no_change, "error", logArgs);

  //////////////////////////////////////////// Setup /////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  const { playbackProgress } = CHANGES;
  const { progressBar } = this.ref;
  this.logger("state-change", msgs.stateChange(playbackProgress), "default", logArgs);

  //////////////////////////////////// State change execution ////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  // [action]...

  /////////////////////// Progress bar width updt. ///////////////////////
  ////////////////////////////////////////////////////////////////////////

  progressBar.style.setProperty("--w", `${playbackProgress}%`);
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
